export const PLATFORM_SIZE = 46
export const PLATFORM_LOOP_HEIGHT_SIZE = 66
export const PLATFORM_LOOP_WIDTH_SIZE = 50
export const PLATFORM_TEXT_Y_OFFSET = 6
export const PLATFORM_CORRESPONDANCE_X_OFFSET = 70
export const PLATFORM_CORRESPONDANCE_Y_OFFSET = 54
export const PLATFORM_CORRESPONDANCE_WIDTH = 30
export const PLATFORM_CORRESPONDANCE_HEIGHT = 20
